import React from "react";
import { Skeleton } from "../../../../shadcn/components/ui/skeleton";
interface AuctionLoaderProps {
  type?: string;
}

export default function AuctionLoader({ type = "bidder" }: AuctionLoaderProps) {
  return (
    <>
      {type === "home" && (
        <div className="space-y-4">
          <div className="grid lg:grid-cols-3 items-center space-x-4 bg-white p-4">
            <Skeleton className="h-[250px] max-w-screen col-span-2" />
            <div className="hidden lg:grid grid-cols-2 space-x-4">
              <Skeleton className="h-[250px] max-w-screen" />
              <Skeleton className="h-[250px] max-w-screen" />
            </div>
          </div>
          <div className="grid lg:grid-cols-3 items-center space-x-4 bg-white p-4">
            <Skeleton className="h-[250px] max-w-screen col-span-2" />
            <Skeleton className="h-[250px] max-w-screen hidden lg:inline-block" />
          </div>
        </div>
      )}
      {type === "bidder" && (
        <div
          role="status"
          className="py-4 bg-white space-y-4 border border-gray-200 divide-y divide-gray-200 rounded shadow animate-pulse dark:divide-gray-700 md:p-6 dark:border-gray-700"
        >
          <div className="flex items-center justify-between">
            <div>
              <div className="h-2.5 bg-gray-300 rounded-full dark:bg-gray-600 w-24 mb-2.5"></div>
              <div className="w-32 h-2 bg-gray-200 rounded-full dark:bg-gray-700"></div>
            </div>
            <div className="h-2.5 bg-gray-300 rounded-full dark:bg-gray-700 w-12"></div>
          </div>
          <div className="flex items-center justify-between pt-4">
            <div>
              <div className="h-2.5 bg-gray-300 rounded-full dark:bg-gray-600 w-24 mb-2.5"></div>
              <div className="w-32 h-2 bg-gray-200 rounded-full dark:bg-gray-700"></div>
            </div>
            <div className="h-2.5 bg-gray-300 rounded-full dark:bg-gray-700 w-12"></div>
          </div>
          <div className="flex items-center justify-between pt-4">
            <div>
              <div className="h-2.5 bg-gray-300 rounded-full dark:bg-gray-600 w-24 mb-2.5"></div>
              <div className="w-32 h-2 bg-gray-200 rounded-full dark:bg-gray-700"></div>
            </div>
            <div className="h-2.5 bg-gray-300 rounded-full dark:bg-gray-700 w-12"></div>
          </div>
          <div className="flex items-center justify-between pt-4">
            <div>
              <div className="h-2.5 bg-gray-300 rounded-full dark:bg-gray-600 w-24 mb-2.5"></div>
              <div className="w-32 h-2 bg-gray-200 rounded-full dark:bg-gray-700"></div>
            </div>
            <div className="h-2.5 bg-gray-300 rounded-full dark:bg-gray-700 w-12"></div>
          </div>
          <div className="flex items-center justify-between pt-4">
            <div>
              <div className="h-2.5 bg-gray-300 rounded-full dark:bg-gray-600 w-24 mb-2.5"></div>
              <div className="w-32 h-2 bg-gray-200 rounded-full dark:bg-gray-700"></div>
            </div>
            <div className="h-2.5 bg-gray-300 rounded-full dark:bg-gray-700 w-12"></div>
          </div>
          <span className="sr-only">Loading...</span>
        </div>
      )}
    </>
  );
}
